import { create } from 'zustand';

type CompanyStore = {
  companyListPage: number;
  setCompanyListPage: (page: number) => void;
  isOpenCompanyModal: boolean;
  openCompanyModal: () => void;
  companyListLimit: number;
  setCompanyListLimit: (limit: number) => void;
};

export const useCompanyStore = create<CompanyStore>()((set) => ({
  companyListPage: 1,
  setCompanyListPage: (companyListPage) => set({ companyListPage }),
  isOpenCompanyModal: false,
  companyListLimit: 10,
  openCompanyModal: () =>
    set((state) => ({ isOpenCompanyModal: !state.isOpenCompanyModal })),
  setCompanyListLimit: (companyListLimit) => set({ companyListLimit }),
}));
